export default "__VITE_ASSET__B1pXYA5Z__"